
import hi from "./hi.json";
import en_GB from "./en_gb.json";

export type JanusLabels = {
    logo: string;
    name: string;
    lang: string;
    rivtn: string;
    support_t: string;
    short_lang: string;
    short_name: string;
    welcome_title: string;
    welcome_content: string;
    common: {
        continue: string;
        rivtn_support_center: string;
    };
    header: {
        login: string;
        search: string;
        sign_out: string;
        hero_desc: string;
        hero_title: string;
        your_tickets: string;
        menu_items: {
            label: string;
            location: string;
        }[];
    };
    contact: {
        title: string;
        videos: string;
        weekend: string;
        articles: string;
        holidays: string;
        documents: string;
        resources: string;
        contact_us: string;
        communities: string;
        get_in_touch: string;
        monday_to_friday: string;
        dont_find_answer: string;
        links: {
            desc: string;
            title: string;
            image: string;
            location?: string;
        }[];
    };
    footer: {
        copyright: string;
        follow_us: string;
        socials: {
            icon: string;
            location: string;
        }[];
        locations: {
            label: string;
            location: string;
        }[][];
    };
    landing: {
        got_questions: string;
        we_got_answers: string;
        browse_categories: string;
        fgs: {
            icon: string;
            desc: string;
            title: string;
            action_label: string;
            action_location: string;
        }[];
    };
    search_and_404: {
        search_result: string;
        nothing_found: string;
        previous_page: string;
        page_not_exist: string;
        go_to_homepage: string;
        faqs_that_matches: string;
        tickets_that_matches: string;
        articles_that_matches: string;
        sorry_try_search_again: string;
    };
    faqs: {
        title: string;
        long_title: string;
    };
    support_category: {
        long_title: string;
    };
    support_article: {
        thanks: string;
        was_article_helpful: string;
        articles_in_category: string;
    };
    support: {
        title: string;
        ticket: {
            create: {
                desc: string;
                submit: string;
                message: string;
                thank_you: string;
                contact_info: string;
                submit_a_ticket: string;
                select_category: string;
                will_be_in_touch: string;
                submit_a_request: string;
                submission_received: string;
                category_and_message_required: string;
            };
            tickets: {
                title: string;
                search: string;
                status: string;
                filter: {
                    title: {
                        name: string;
                        placeholder: string;
                    };
                    date: {
                        name: string;
                        placeholder: string;
                    };
                    statuses: {
                        label: string;
                        value: string;
                    }[];
                };
                status_map: {
                    closed: string;
                    stalled: string;
                    resolved: string;
                    re_opened: string;
                    unresolved: string;
                };
                table: {
                    columns: {
                        date: string;
                        title: string;
                        status: string;
                        participants: string;
                    };
                    popover: {
                        view: string;
                        reopen: string;
                        mark_resolve: string;
                        close_ticket: string;
                    };
                };
            };
            ticket: {
                attachments: string;
                missing_comment_attachment: string;
                statuses: {
                    new: string;
                };
                controls: {
                    send: string;
                    edit: string;
                    reply: string;
                    medias: string;
                    attach: string;
                    preview: string;
                    documents: string;
                    send_ticket_thread: string;
                };
            };
        };
    };
};

export type LanguageMap = { [key: string]: JanusLabels };

const languages: LanguageMap = {
    hi,
    en_GB,
};

let i18nData: JanusLabels;
let defaultLanguage: string;

export const i18nManager = {

    Labels: i18nData!,
    LabeslLoaded: false,
    ActiveLanguage: defaultLanguage!,
    Languages: [
        {
            "value": "en-GB",
            "label": "English - GB"
        },
        /*{
            "value": "hi",
            "label": "Hindi"
        }*/
    ],

    switchLanguage(lang: string) {
        localStorage.setItem("rivtn.language", lang);
        window.location.reload();
    }

};

if (!i18nManager.LabeslLoaded) {
    //localStorage.setItem("rivtn.language", "es") // uncomment to test spanish
    //localStorage.setItem("rivtn.language", "en") // uncomment to test english

    defaultLanguage = navigator.language;
    if (localStorage.getItem("rivtn.language") !== null && localStorage.getItem("rivtn.language") !== "") {
        defaultLanguage = localStorage.getItem("rivtn.language") ?? "en_GB";
    }
    defaultLanguage = defaultLanguage.replace('-', '_');
    if (!(defaultLanguage in languages)) defaultLanguage = "en_GB";
    i18nData = languages[defaultLanguage] ?? languages["en_GB"];
    i18nManager.Labels = i18nData;
    i18nManager.LabeslLoaded = true;
    i18nManager.ActiveLanguage = defaultLanguage;
}